import Vue from 'vue'
import Router from 'vue-router'
import AdminHome from '@/components/adminHome/adminHome'
import ClientHome from '@/components/clienthome'
import ClientMatter from '@/components/users/clientMatter'
import ClientDocs from '@/components/documents/clientDocs'
import ClientInvoices from '@/components/accounts/clientInvoices'
import User from '@/components/users/user'
import Users from '@/components/users/users'
import NewUser from '@/components/users/newUser'
import SetPassword from '@/components/users/setPassword'
import Visatypes from '@/components/visatypes'
import Visatype from '@/components/visatypes/visatype'
import Matters from '@/components/matters'
import Matter from '@/components/matter'
import Accounts from '@/components/accounts/accounts'
import Invoice from '@/components/accounts/invoice'
import Receipt from '@/components/accounts/receipt'
import Pay from '@/components/accounts/pay'
import Agreements from '@/components/agreements/agreements'
import ProfileWrapper from '@/components/users/profileWrapper'
import Vevo from '@/components/vevo'
import ChooseDocCategory from '@/components/docs/chooseDocCategory'
import ChooseDocType from '@/components/docs/chooseDocType'
import EditTemplate from '@/components/docs/edit_template'
import MakeDoc from '@/components/docs/makeDoc'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  routes: [
    { path: '/', components: { default: AdminHome, client: ClientHome } },
    { path: '/visatypes', component: Visatypes },
    { path: '/visatype/:id', component: Visatype, props: true },
    { path: '/accounts', component: Accounts },
    { path: '/agreements', component: Agreements },
    { path: '/invoices/:id', component: Invoice },
    { path: '/receipts/:id', component: Receipt },
    { path: '/matters', component: Matters },
    { path: '/matters/:matter_id', component: Matter, props: true },
    { path: '/pay', component: Pay },
    { path: '/userlist/:usertype', component: Users, props: true },
    { path: '/users/:id', component: User, props: true },
    { path: '/newUser/:usertype', component: NewUser, props: true },
    { path: '/users/setpassword/:code', component: SetPassword, props: true },
    { path: '/vevo', component: Vevo },

    // Docs
    { path: '/docs/choosecategory/:to_editor/:matter_id', component: ChooseDocCategory, props: true },
    { path: '/docs/choosetype/:to_editor/:matter_type/:matter_id', component: ChooseDocType, props: true },
    { path: '/docs/edit/:new/:id', component: EditTemplate, props: true },
    { path: '/docs/make/:type_id/:matter_id', component: MakeDoc, props: true },

    // Client routes
    { path: '/clienthome', components: { client: ClientHome } },
    { path: '/profile', components: { default: ProfileWrapper, client: ProfileWrapper } },
    { path: '/invoices', components: { client: ClientInvoices } },
    { path: '/documents', components: { client: ClientDocs } },
    { path: '/client-matter/:index', components: { client: ClientMatter } }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js